import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgSecurity(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M68.813 82.371c0-2.42 1.51-4.548 3.637-5.702 10.08-5.47 16.925-16.145 16.925-28.42 0-17.846-14.467-32.313-32.313-32.313-17.845 0-32.312 14.467-32.312 32.313 0 12.274 6.844 22.95 16.925 28.42 2.127 1.154 3.638 3.282 3.638 5.702V83.5h23.5V82.37Z"
        fill="#FC0"
      />
      <path
        d="M50.388 48.249a2.138 2.138 0 1 0-3.664 1.496l3.664 3.664v-5.16Zm17.625 0a2.138 2.138 0 0 0-4.276 0v5.16l3.664-3.664c.38-.387.612-.913.612-1.496Zm1.6 0a3.728 3.728 0 0 1-1.07 2.616l-4.684 4.684c-.04.04-.08.078-.122.116v27.834a.8.8 0 1 1-1.6 0v-26.97a3.734 3.734 0 0 1-3.563-.98 2.138 2.138 0 0 0-3.023 0 3.734 3.734 0 0 1-3.564.98v26.97a.8.8 0 1 1-1.6 0V55.665a3.886 3.886 0 0 1-.121-.116l-4.685-4.684a3.737 3.737 0 1 1 6.406-2.616v6.585c.795.38 1.775.243 2.433-.415a3.737 3.737 0 0 1 5.285 0 2.136 2.136 0 0 0 2.433.415v-6.585a3.737 3.737 0 1 1 7.474 0Z"
        fill="#fff"
      />
      <path
        d="M51.58 99.239h10.574a4.7 4.7 0 0 1-4.7 4.7H56.28a4.7 4.7 0 0 1-4.7-4.7Z"
        fill="#B3C0D0"
      />
      <path
        d="m45.075 96.847 2.433 2.434a5.876 5.876 0 0 0 4.154 1.72H62.07a5.876 5.876 0 0 0 4.155-1.72l2.433-2.434a5.873 5.873 0 0 0 1.193-1.72h-25.97c.29.634.691 1.218 1.194 1.72Z"
        fill="#599F40"
      />
      <path
        d="M45.117 83.376c-.974 0-1.763.79-1.763 1.763v7.554c0 .847.183 1.676.528 2.433h25.97a5.874 5.874 0 0 0 .527-2.433v-7.554c0-.974-.789-1.763-1.762-1.763h-23.5Z"
        fill="#78B441"
      />
      <path d="M64.505 94.326a.8.8 0 0 1 0 1.6H49.229a.8.8 0 1 1 0-1.6h15.276Z" fill="#007A5F" />
      <path
        d="M30.804 48.248c0-1.11.07-2.206.204-3.281a.8.8 0 0 1 1.587.198 24.907 24.907 0 0 0-.191 3.083.8.8 0 1 1-1.6 0Zm26.258-26.257a.8.8 0 1 1 0 1.6c-9.126 0-17.094 4.957-21.36 12.33a.8.8 0 0 1-1.384-.803c4.54-7.846 13.024-13.127 22.744-13.128Z"
        fill="#fff"
      />
      <path
        d="M36.5 74.686c0 6.49-5.26 11.75-11.75 11.75S13 81.176 13 74.686s5.26-11.75 11.75-11.75 11.75 5.26 11.75 11.75Z"
        fill="#78B441"
      />
      <path
        d="M24.75 71.161a3.525 3.525 0 1 0 3.324 4.7h2.433a5.875 5.875 0 1 1 0-2.35h-2.433a3.526 3.526 0 0 0-3.324-2.35Z"
        fill="#fff"
      />
      <path
        d="M77.625 32.806c0-.859.607-1.597 1.448-1.774 5.684-1.197 11.075-2.718 12.726-3.196a1.85 1.85 0 0 1 1.027 0c1.65.478 7.042 1.999 12.726 3.196A1.818 1.818 0 0 1 107 32.806v12.646c0 8.774-10.87 15.391-13.907 17.07a1.594 1.594 0 0 1-1.56 0c-3.038-1.679-13.908-8.296-13.908-17.07V32.807Z"
        fill="#599F40"
      />
      <path
        d="M101.713 43.255c0 5.354-4.209 9.694-9.4 9.694-5.192 0-9.4-4.34-9.4-9.694 0-5.354 4.208-9.694 9.4-9.694 5.191 0 9.4 4.34 9.4 9.694Z"
        fill="#E6F4F0"
      />
      <path
        d="M95.243 40.664a.8.8 0 0 1 1.189 1.07l-4.23 4.7a.8.8 0 0 1-1.189 0l-2.82-3.134a.8.8 0 0 1 1.19-1.07l2.224 2.473 3.636-4.04Z"
        fill="#78B441"
      />
    </svg>
  )
}
export default wrapIllustration(SvgSecurity)
